import { createContext, useEffect } from 'react';
import ProjectDatas from '../Datas/projects';
import { useLocalState } from '../Hooks/use-local-state';


export const ProjectContext = createContext(ProjectDatas);



export const ProjectContextProvider = ({ children }) => {
    const [ harvestData, setHarvestData ] = useLocalState("harvest", ProjectDatas.harvest);
    const [ cryptoVolcanicData, setCryptoVolcanicData ] = useLocalState("crypto_volcanic", ProjectDatas.crypto_volcanic);


    useEffect(() => {
        const interval = setInterval(() => {
            setHarvestData(Object.assign(harvestData, { currentInvestement: harvestData.currentInvestement + Math.floor(Math.random() * 10 + 1)  }))
        }, 1000);
        return () => clearInterval(interval)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <ProjectContext.Provider value={{
        harvest: {
            data: harvestData,
            updateData: setHarvestData
        },
        crypto_volcanic: {
            data: cryptoVolcanicData,
            updateData: setCryptoVolcanicData
        }
    }}>{ children }</ProjectContext.Provider>
}